import { render, staticRenderFns } from "./Flipbook.vue?vue&type=template&id=3a90e16c&scoped=true&"
import script from "./Flipbook.vue?vue&type=script&lang=js&"
export * from "./Flipbook.vue?vue&type=script&lang=js&"
import style0 from "./Flipbook.vue?vue&type=style&index=0&id=3a90e16c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a90e16c",
  null
  
)

export default component.exports